import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Image, View, TouchableOpacity, Text } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { styles } from './AvailabilitySubscrnBottomSheet.styles';
import ASSETS from '../../../../Utils/Assets/RailsAssets';
import { _label } from 'apps/rails/src/vernacular/AppLanguage';
import { colors } from '@mmt/legacy-commons/Styles/globalStyles';
import {
  displayAvailSubscrnBottomSheet,
  updateAvailabilitySubscription,
} from '../../TravelerDetailsActions';
import { getConfigStore } from 'apps/rails/src/configStore/Common/RailsConfigStoreUtils';
import { configKeys } from 'apps/rails/src/configStore/Common/constants';
import { trackTravellerPageEvent } from 'apps/rails/src/railsAnalytics';
import RAIL_EVENTS from 'apps/rails/src/RailsOmnitureTracker';
import { isUserLoggedIn } from '@mmt/legacy-commons/Native/UserSession/UserSessionModule';
import { withCookies } from 'react-cookie';
import { LOGIN_PAGE_URL } from '@mmt/rails/src/RailsConfig';

const enabledColors = ['#53b2ff', '#065af3'];

interface AvailabilitySubscrnBottomSheetProps {
  closeAvailSubscrnBottomSheet: () => void;
  updateAvailabilitySubscription: () => void;
  isAvailSubscrnEnabled: boolean;
  cookies: any;
}

const AvailabilitySubscrnBottomSheet = ({
  closeAvailSubscrnBottomSheet,
  updateAvailabilitySubscription,
  isAvailSubscrnEnabled,
  cookies,
}: AvailabilitySubscrnBottomSheetProps) => {
  const [availSubscrnConfig, setAvailSubscrnConfig] = useState({});
  const [isUserLogged, setIsUserLogged] = useState(false);

  useEffect(() => {
    async function initializeAvailAlertConfig() {
      const config = await getConfigStore(configKeys.RAILS_AVAILABILITY_SUBSCRIPTION);
      setAvailSubscrnConfig(config?.bottomSheet || {});
    }
    initializeAvailAlertConfig();
    trackTravellerPageEvent(RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_ALERT_BS_SHOWN);
  }, []);

  useEffect(() => {
    const checkLoginStatus = async () => {
      const loggedIn = await isUserLoggedIn();
      setIsUserLogged(loggedIn);
    };
    checkLoginStatus();
  }, []);

  useEffect(() => {
    const postLoginAction = sessionStorage.getItem('postLoginAction');
    if (postLoginAction === 'toggleSwitch' && isUserLogged) {
      updateAvailabilitySubscription();
      closeAvailSubscrnBottomSheet();
      sessionStorage.removeItem('postLoginAction');
    }
  }, [isUserLogged, updateAvailabilitySubscription, closeAvailSubscrnBottomSheet]);

  const goToLoginPage = () => {
    const loginActionDetails = {
      actionURL: window.location.href,
      verifyOTP: false,
      isOTPVerified: false,
      openVerifiedPage: false,
      optPageOpened: false,
      postLoginAction: 'toggleSwitch',
    };
    const expires = new Date(Date.now() + 1200000);
    cookies.set('loginActionDetails', JSON.stringify(loginActionDetails), {
      expires,
      path: '/',
      domain: '.makemytrip.com',
    });
    sessionStorage.setItem('postLoginAction', 'toggleSwitch');
    window.location.href = LOGIN_PAGE_URL;
  };
  const onPrimaryButtonClick = async () => {
    const loggedIn = await isUserLoggedIn();
      if(!loggedIn){
        goToLoginPage();
      }else{
        updateAvailabilitySubscription();
        closeAvailSubscrnBottomSheet();
      }
  };
  return (
    <>
      <View style={styles.container}>
        <TouchableOpacity
          style={styles.stickyCloseButton}
          onPress={() => {
            closeAvailSubscrnBottomSheet();
          }}
        >
          <Image source={ASSETS.crossIcon} style={styles.closeIcon} />
        </TouchableOpacity>
        <Image style={styles.icon} source={ASSETS.availabilitySubscriptionIcon} />
        <Text style={styles.title}>
          {isAvailSubscrnEnabled
            ? availSubscrnConfig?.enabled?.title
            : availSubscrnConfig?.disabled?.title}
        </Text>
        <Text style={styles.description}>
          {isAvailSubscrnEnabled
            ? availSubscrnConfig?.enabled?.description
            : availSubscrnConfig?.disabled?.description}
        </Text>
        <View style={styles.buttonContainer}>
          <TouchableOpacity
            onPress={onPrimaryButtonClick}
            feedbackColor={colors.transparent}
            style={styles.blueButton}
          >
            <LinearGradient
              style={styles.linearGrad}
              colors={enabledColors}
              start={{
                x: 0,
                y: 2,
              }}
              end={{
                x: 1,
                y: 1,
              }}
            >
              <Text style={styles.blueButtonText}>
                {_label(isAvailSubscrnEnabled ? 'remove_alert' : 'yes_notify_me', {
                  uppercase: true,
                })}
              </Text>
            </LinearGradient>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={closeAvailSubscrnBottomSheet}
            feedbackColor={colors.transparent}
            style={styles.secondaryButton}
          >
            <Text style={styles.secondaryButtonText}>
              {_label(isAvailSubscrnEnabled ? 'got_it' : 'skip', { uppercase: true })}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </>
  );
};

const mapStateToProps = (state: any) => {
  const {
    railsTraveler: { availabilitySubscription: { isAvailSubscrnEnabled = false } = {} } = {},
  } = state;

  return {
    isAvailSubscrnEnabled,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  closeAvailSubscrnBottomSheet: () => dispatch(displayAvailSubscrnBottomSheet(false)),
  updateAvailabilitySubscription: () => dispatch(updateAvailabilitySubscription()),
});

export default withCookies(connect(mapStateToProps, mapDispatchToProps)(AvailabilitySubscrnBottomSheet));
